'use strict'

/**
 * @type {Array}
 * @description The available types of element we want to render
 * as a an action grid item
 */
export const types = ['button', 'a', 'router-link', 'RouterLink']

/**
 * @type {Array}
 * @description When the "type" of element is set to button these
 * would be the available types of HTMLButtonElement's that can
 * be used
 */
export const nativeTypes = ['button', 'submit', 'reset']

/**
 * @type {Array}
 * @description Different sizes for action grid items
 */
export const sizes = ['none', 'small', 'large', 'full', 'huge']
